import activityItemTable from "./activity-item-table.json";
import analysisModal from "./analysis-modal.json";
import analysis from "./analysis.json";
import bulkUpload from "./bulk-upload.json";
import callout from "./callout.json";
import common from "./common.json";
import consolidatedWorker from "./consolidated-worker.json";
import dashboard from "./dashboard.json";
import documents from "./documents.json";
import filesReportsMessages from "./files-reports-messages.json";
import loginPage from "./login-page.json";
import manualValidationModal from "./manual-validation-modal.json";
import message from "./message.json";
import navbarLinks from "./navbar-links.json";
import profileCommons from "./profile-commons.json";
import reports from "./reports.json";
import sheFile from "./she-file.json";
import sidebar from "./sidebar.json";
import sowProfile from "./sow-profile.json";
import sowTable from "./sow-table.json";
import statusList from "./status-list.json";
import supplierList from "./supplier-list.json";
import supplierProfile from "./supplier-profile.json";
import workerProfile from "./worker-profile.json";
import dates from "./dates.json";
import status from "./status.json";
import sideDrawer from "./side-drawer.json";
import modals from "./modals.json";
import customFields from "./custom-fields.json";
import profile from "./profile.json";
import userList from "./user-list.json";
import error from "./error.json";
import listErrors from "./list-errors.json";
import listMessages from "./list-messages.json";
import breadcrumbs from "./breadcrumbs.json";
import formCreateWorker from "./form-create-worker.json";
import logSystem from "./log-system.json";
import logDescription from "./log-description.json";
import releaseNotes from "./release-notes.json";

const map = {
  "activity-item-table": activityItemTable,
  "analysis-modal": analysisModal,
  analysis: analysis,
  "bulk-upload": bulkUpload,
  callout: callout,
  common: common,
  "consolidated-worker": consolidatedWorker,
  dashboard: dashboard,
  documents: documents,
  "files-reports-messages": filesReportsMessages,
  "login-page": loginPage,
  "manual-validation-modal": manualValidationModal,
  message: message,
  "navbar-links": navbarLinks,
  "profile-commons": profileCommons,
  reports: reports,
  "she-file": sheFile,
  sidebar: sidebar,
  "sow-profile": sowProfile,
  "sow-table": sowTable,
  "status-list": statusList,
  "supplier-list": supplierList,
  "supplier-profile": supplierProfile,
  "worker-profile": workerProfile,
  dates: dates,
  status: status,
  "side-drawer": sideDrawer,
  modals: modals,
  "custom-fields": customFields,
  profile: profile,
  "user-list": userList,
  error: error,
  "list-errors": listErrors,
  "list-messages": listMessages,
  breadcrumbs: breadcrumbs,
  "form-create-worker": formCreateWorker,
  "log-system": logSystem,
  "log-description": logDescription,
  "release-notes": releaseNotes,
};

export default map;
